import React, { lazy } from 'react';
import Login from 'features/login';
import Layout from 'components/common/Layout';
import { RouteObject } from 'react-router';

const Dashboard = lazy(() => import('features/dashboard'));
const Banner = lazy(() => import('features/banner'));
const ListPost = lazy(() => import('features/listPost'));
const RiskManagement = lazy(() => import('features/riskManagement'));
const PushNotification = lazy(() => import('features/pushNotification'));
const CreatePost = lazy(() => import('features/listPost/create'));
const CreateBanner = lazy(() => import('features/banner/CreateBanner'));
const EditBanner = lazy(() => import('features/banner/EditBanner'));
const Categories = lazy(() => import('features/listPost/categories'));
// const Layout = lazy(() => import('components/common/Layout'));

export default function useListRouter(): RouteObject[] {
  return [
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Dashboard />
        },
        {
          path: 'banner',
          children: [
            {
              index: true,
              element: <Banner />
            },
            {
              path: 'create',
              element: <CreateBanner />
            },
            {
              path: 'edit/:id',
              element: <EditBanner />
            }
          ]
        },
        {
          path: 'categories',
          element: <Categories />
        },
        {
          path: 'posts',
          children: [
            {
              index: true,
              element: <ListPost />
            },
            {
              path: 'create',
              element: <CreatePost />
            },
            {
              path: ':postId',
              element: <CreatePost />
            }
          ]
        },
        {
          path: '/risk-management',
          element: <RiskManagement />
        },
        {
          path: '/push-notification',
          element: <PushNotification />
        }
      ]
    },
    {}
  ];
}

// export { listRouterConfig };
